import { IconType } from "./icons.types";

const SearchIcon = ({ className, color }: IconType) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77767 10.8889C2.77767 15.1844 6.2599 18.6667 10.5554 18.6667C14.851 18.6667 18.3332 15.1844 18.3332 10.8889C18.3332 6.59333 14.851 3.1111 10.5554 3.1111C6.2599 3.1111 2.77767 6.59333 2.77767 10.8889ZM10.5554 20C5.52352 20 1.44434 15.9208 1.44434 10.8889C1.44434 5.85696 5.52352 1.77777 10.5554 1.77777C15.5874 1.77777 19.6666 5.85696 19.6666 10.8889C19.6666 13.1649 18.832 15.246 17.4522 16.8428L20.3602 19.7508C20.6205 20.0112 20.6205 20.4333 20.3602 20.6936C20.0998 20.954 19.6777 20.954 19.4174 20.6936L16.5094 17.7857C14.9126 19.1654 12.8315 20 10.5554 20Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
